// This file is auto-generated by Velocious. Do not edit it manually — any changes
// will be overwritten the next time it is generated. Run `velocious generate:frontend-models` to regenerate.
import FrontendModelBase from "velocious/build/src/frontend-models/base.js"

/**
 * Frontend model resource config.
 * @typedef {import("velocious/build/src/frontend-models/base.js").FrontendModelResourceConfig} FrontendModelResourceConfig
 */
/**
 * Fallback attribute value type for generated fields without narrower metadata.
 * @typedef {import("velocious/build/src/frontend-models/base.js").FrontendModelAttributeValue} FrontendModelAttributeValue
 */

/**
 * TaskTypeAttributes type.
 * @typedef {object} TaskTypeAttributes
 * @property {Date | null} createdAt - Attribute value.
 * @property {boolean} defaultForProject - Attribute value.
 * @property {string} id - Attribute value.
 * @property {string | null} name - Attribute value.
 * @property {string | null} projectId - Attribute value.
 * @property {Date | null} updatedAt - Attribute value.
 */
/**
 * Attributes accepted by TaskTypeCreateAttributes.
 * @typedef {object} TaskTypeCreateAttributes
 * @property {TaskTypeAttributes["defaultForProject"] | null} [defaultForProject] - Permitted defaultForProject value.
 * @property {TaskTypeAttributes["name"] | null} [name] - Permitted name value.
 * @property {TaskTypeAttributes["projectId"] | null} [projectId] - Permitted projectId value.
 */
/**
 * Attributes accepted by TaskTypeUpdateAttributes.
 * @typedef {object} TaskTypeUpdateAttributes
 * @property {TaskTypeAttributes["defaultForProject"] | null} [defaultForProject] - Permitted defaultForProject value.
 * @property {TaskTypeAttributes["name"] | null} [name] - Permitted name value.
 * @property {TaskTypeAttributes["projectId"] | null} [projectId] - Permitted projectId value.
 */
/**
 * Frontend model for TaskType.
 * @augments {FrontendModelBase<TaskTypeAttributes, TaskTypeCreateAttributes, TaskTypeUpdateAttributes, TaskTypeAttributes["id"], string>}
 */
class TaskType extends FrontendModelBase {
  /** @returns {FrontendModelResourceConfig} - Resource config. */
  static resourceConfig() {
    return {
      modelName: "TaskType",
      attributes: [
        "createdAt",
        "defaultForProject",
        "id",
        "name",
        "projectId",
        "updatedAt",
      ],
    }
  }

  /** @returns {Record<string, {type: "belongsTo" | "hasOne" | "hasMany", autoload?: boolean}>} - Relationship definitions. */
  static relationshipDefinitions() {
    return {
      project: {type: "belongsTo"},
    }
  }

  /** @returns {Record<string, string>} - Relationship model class names. */
  static relationshipModelClasses() {
    return {
      project: "Project",
    }
  }

  /** @returns {TaskTypeAttributes["createdAt"]} - Attribute value. */
  createdAt() { return /** @type {TaskTypeAttributes["createdAt"]} */ (this.readAttribute("createdAt")) }

  /**
   * @param {Date | string | null} newValue - New attribute value.
   * @returns {Date | string | null} - Assigned value.
   */
  setCreatedAt(newValue) { return /** @type {Date | string | null} */ (this.setAttribute("createdAt", newValue)) }

  /** @returns {TaskTypeAttributes["defaultForProject"]} - Attribute value. */
  defaultForProject() { return /** @type {TaskTypeAttributes["defaultForProject"]} */ (this.readAttribute("defaultForProject")) }

  /**
   * @param {TaskTypeAttributes["defaultForProject"] | null} newValue - New attribute value.
   * @returns {TaskTypeAttributes["defaultForProject"] | null} - Assigned value.
   */
  setDefaultForProject(newValue) { return /** @type {TaskTypeAttributes["defaultForProject"] | null} */ (this.setAttribute("defaultForProject", newValue)) }

  /** @returns {TaskTypeAttributes["id"]} - Attribute value. */
  id() { return /** @type {TaskTypeAttributes["id"]} */ (this.readAttribute("id")) }

  /**
   * @param {TaskTypeAttributes["id"] | null} newValue - New attribute value.
   * @returns {TaskTypeAttributes["id"] | null} - Assigned value.
   */
  setId(newValue) { return /** @type {TaskTypeAttributes["id"] | null} */ (this.setAttribute("id", newValue)) }

  /** @returns {TaskTypeAttributes["name"]} - Attribute value. */
  name() { return /** @type {TaskTypeAttributes["name"]} */ (this.readAttribute("name")) }

  /**
   * @param {TaskTypeAttributes["name"] | null} newValue - New attribute value.
   * @returns {TaskTypeAttributes["name"] | null} - Assigned value.
   */
  setName(newValue) { return /** @type {TaskTypeAttributes["name"] | null} */ (this.setAttribute("name", newValue)) }

  /** @returns {TaskTypeAttributes["projectId"]} - Attribute value. */
  projectId() { return /** @type {TaskTypeAttributes["projectId"]} */ (this.readAttribute("projectId")) }

  /**
   * @param {TaskTypeAttributes["projectId"] | null} newValue - New attribute value.
   * @returns {TaskTypeAttributes["projectId"] | null} - Assigned value.
   */
  setProjectId(newValue) { return /** @type {TaskTypeAttributes["projectId"] | null} */ (this.setAttribute("projectId", newValue)) }

  /** @returns {TaskTypeAttributes["updatedAt"]} - Attribute value. */
  updatedAt() { return /** @type {TaskTypeAttributes["updatedAt"]} */ (this.readAttribute("updatedAt")) }

  /**
   * @param {Date | string | null} newValue - New attribute value.
   * @returns {Date | string | null} - Assigned value.
   */
  setUpdatedAt(newValue) { return /** @type {Date | string | null} */ (this.setAttribute("updatedAt", newValue)) }

  /**
   * Returns project relationship helper.
   * @returns {import("velocious/build/src/frontend-models/base.js").FrontendModelSingularRelationship<TaskType, import("./project.js").Project, import("./project.js").ProjectCreateAttributes>} - Relationship helper.
   */
  projectRelationship() { return /** @type {import("velocious/build/src/frontend-models/base.js").FrontendModelSingularRelationship<TaskType, import("./project.js").Project, import("./project.js").ProjectCreateAttributes>} */ (this.getRelationshipByName("project")) }

  /**
   * Returns project.
   * @returns {import("./project.js").Project | null} - Loaded related model.
   */
  project() { return this.projectRelationship().loaded() }

  /**
   * Builds project.
   * @param {import("./project.js").ProjectCreateAttributes} [attributes] - Attributes for the new related model.
   * @returns {import("./project.js").Project} - Built related model.
   */
  buildProject(attributes = {}) { return this.projectRelationship().build(attributes) }

  /**
   * Loads project.
   * @returns {Promise<import("./project.js").Project | null>} - Loaded related model.
   */
  async loadProject() { return await this.projectRelationship().load() }

  /**
   * Returns or loads project.
   * @returns {Promise<import("./project.js").Project | null>} - Loaded related model.
   */
  async projectOrLoad() { return await this.projectRelationship().orLoad() }

  /**
   * Sets project.
   * @param {import("./project.js").Project | null} model - Related model.
   * @returns {void}
   */
  setProject(model) { this.projectRelationship().setLoaded(model) }

  /**
   * Registers a class-level destroy callback.
   * @overload
   * @param {(payload: {id: string}) => void} callback - Event callback.
   * @param {import("velocious/build/src/frontend-models/base.js").FrontendModelEventOptions} [options] - Destroy event options.
   * @returns {Promise<() => void>} - Unsubscribe callback.
   */
  /**
   * @template {import("velocious/build/src/frontend-models/base.js").FrontendModelClass} T
   * @overload
   * @this {T}
   * @param {(payload: {id: import("velocious/build/src/frontend-models/base.js").FrontendModelEventPrimaryKeyValueFor<InstanceType<T>>}) => void} callback - Event callback.
   * @param {import("velocious/build/src/frontend-models/base.js").FrontendModelEventOptions} [options] - Destroy event options.
   * @returns {Promise<() => void>} - Unsubscribe callback.
   */
  /**
   * Implements class-level destroy callback registration.
   * @param {(payload: {id: never}) => void} callback - Type-erased event callback.
   * @param {import("velocious/build/src/frontend-models/base.js").FrontendModelEventOptions} [options] - Destroy event options.
   * @returns {Promise<() => void>} - Unsubscribe callback.
   */
  static async onDestroy(callback, options = {}) {
    return await this._registerDestroyEventCallback(callback, options)
  }
}

FrontendModelBase.registerModel(TaskType)

export {TaskType}

export default TaskType
